import { HelpArticleContent } from '../../components/types';

export const afterCheckIn: HelpArticleContent = {
  title: 'I’ve Checked In. What’s Next?',
  subtitle:
    'Learn what happens after you check in and when to expect your personalised video.',
  sections: [
    {
      id: 'when-will-i-receive-my-video',
      heading: 'When will I receive my video?',
      intro:
        'After you check in, the footage from event you attended needs to be uploaded and processed.',
      blocks: [
        {
          type: 'text',
          text: 'Once the videographer or event organiser uploads the event videos, <b>CrowdClip&reg; AI</b> takes over – analysing the footage and creating personalised highlight reels for each attendee.',
        },
        {
          type: 'text',
          text: 'When your video is ready, you’ll receive an email from <b>hello@crowdclip.com</b> with a direct link to watch, download, and share it.',
        },
        {
          type: 'text',
          text: 'The processing time varies depending on the event size and when the footage is uploaded – sometimes it’s a few days, sometimes a bit longer.',
        },
      ],
    },

    {
      id: 'do-i-need-to-do-anything-else',
      heading: 'Do I need to do anything else?',
      intro:
        'You don’t need to do anything else once your check-in is complete.',
      blocks: [
        {
          type: 'text',
          text: 'All your details are already saved, and our AI will handle the rest automatically. If we ever need more information from you, you’ll receive an email from <b>hello@crowdclip.com</b>.',
        },
      ],
    },

    {
      id: 'how-will-i-know-when-it-s-ready',
      heading: 'How will I know when it’s ready?',
      intro: 'We’ll email you as soon as your video is available.',
      blocks: [
        {
          type: 'text',
          text: 'Once your personalised video has been generated, you’ll get an email from <b>hello@crowdclip.com</b> with a direct link to your video page. From there, you can watch it, download it, and share it on your favourite social media platforms.',
        },
      ],
    },
  ],
};
